import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { PlatformLegalEntityDTO } from '@well/platform-administration/company/domain';
import { TranslateModule } from '@ngx-translate/core';
import { FormUtils } from "@irian-ro/util-forms";
import { InputTextModule } from 'primeng/inputtext';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { ButtonModule } from 'primeng/button';
import {
  PlatformCompanyRegistrationInputsComponent,
  PlatformLegalEntityAddressInputsComponent,
  PlatformLegalEntityBankAccountInputsComponent,
  PlatformLegalEntityInvoicingTermsInputsComponent
} from '@well/libs/platform-administration/company/shared';

@Component({
    selector: 'well-platform-legal-entity-inputs',
    templateUrl: './platform-legal-entity-inputs.component.html',
    styleUrls: ['./platform-legal-entity-inputs.component.scss'],
    imports: [
        FormsModule,
        TranslateModule,
        InputTextModule,
        SharedComponentsModule,
        ButtonModule,
        PlatformLegalEntityAddressInputsComponent,
        PlatformLegalEntityBankAccountInputsComponent,
        PlatformLegalEntityInvoicingTermsInputsComponent,
        PlatformCompanyRegistrationInputsComponent
    ],
    standalone: true
})
export class PlatformLegalEntityInputsComponent {

  @Input() platformLegalEntityDTO: PlatformLegalEntityDTO | undefined = undefined;

  @Output() submitForm: EventEmitter<PlatformLegalEntityDTO> = new EventEmitter<PlatformLegalEntityDTO>();

  @Output() cancelForm: EventEmitter<boolean> = new EventEmitter<boolean>();

    onSubmit(platformLegalEntityInputsForm: NgForm) {
        FormUtils.markAllAsDirty(platformLegalEntityInputsForm.form);
        FormUtils.markAllAsTouched(platformLegalEntityInputsForm.form);
        if(platformLegalEntityInputsForm.valid){
            this.submitForm.emit(this.platformLegalEntityDTO);
        }
    }

    onCancel(): void {
        this.cancelForm.emit(true);
    }
}
